// extracted by mini-css-extract-plugin
export default {"PaginationButton":"PaginationButton-module__PaginationButton___1ys3g","inverse":"PaginationButton-module__inverse___1G4J1"};